exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lora-item-graphic {\n  background: white;\n  padding-top: 15px;\n  padding-bottom: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/graphic/graphic-ui.component.sass
// module id = ../../../../../src/app/components/graphic/graphic-ui.component.sass
// module chunks = main